import React from 'react';
import { Button, Badge } from 'react-bootstrap';
export default function CompanyUserItem(_ref) {
  let {
    companyUser,
    handleDelete,
    index
  } = _ref;
  return /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    className: "text-dark",
    bg: "body"
  }, companyUser.company.name, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex ms-1",
    onClick: () => handleDelete(index)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-warning"
  }, "delete")));
}